module.exports = __webpack_public_path__ + "static/media/contactus_img.b12af4c5.svg";